/**
 * Disappearing timers on photos, files, voice notes and stickers (phone parity, review M3):
 * the chat's timer travels inside the CT 9 body as `disappearSeconds`, and both sides purge the
 * message after that time. Text and polls carry it as the "\u0002seconds\u0002" prefix instead.
 */
export function withDisappearSeconds(wireBody: string, seconds: number): string {
  if (!seconds) return wireBody;
  try {
    const parsed = JSON.parse(wireBody) as Record<string, unknown>;
    return JSON.stringify({ ...parsed, disappearSeconds: seconds });
  } catch {
    return wireBody;
  }
}

/** A received timer, or undefined when absent / out of range (max 90 days, like text). */
export function inboundTimer(seconds: unknown): number | undefined {
  return typeof seconds === "number" && Number.isInteger(seconds) && seconds > 0 && seconds <= 90 * 86400
    ? seconds
    : undefined;
}
